module.exports = __webpack_public_path__ + "static/media/instruction_4.3018f514.svg";